var _Rect, _Path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Rect, Path } from "react-native-svg";
function SvgPilotIndicator(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Rect || (_Rect = /*#__PURE__*/React.createElement(Rect, {
    width: 20,
    height: 20,
    rx: 8,
    fill: "#A600F9"
  })), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M6.56 14.727V5.273h3.546c.726 0 1.336.135 1.828.406.496.27.87.643 1.122 1.117.256.471.383 1.007.383 1.607 0 .606-.127 1.145-.383 1.615-.255.471-.632.842-1.131 1.113-.499.268-1.113.402-1.842.402h-2.35v-1.408h2.12c.424 0 .772-.074 1.043-.222.27-.148.47-.35.6-.61.132-.258.198-.555.198-.89a1.9 1.9 0 00-.198-.887 1.349 1.349 0 00-.605-.595c-.27-.145-.62-.217-1.048-.217h-1.57v8.023H6.561z",
    fill: "#fff"
  })));
}
export default SvgPilotIndicator;